export default __webpack_public_path__ + "static/media/autonomy.f6c8bdbe.png";